
import "../Foundation/stylable/colors.st.css.js";
import "../Divider/Divider.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_PageSection";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_PageSection__root","content":"wds_1_76_1_PageSection__content","titleColumn":"wds_1_76_1_PageSection__titleColumn","actionsBar":"wds_1_76_1_PageSection__actionsBar","divider":"wds_1_76_1_PageSection__divider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




